module.exports = __webpack_public_path__ + "media/img/skrzynia-manualna@3x-63137a0e.svg";